module.exports = __webpack_public_path__ + "static/media/mpk_modal.876ccd59.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mpk_modal.jpg
// module id = 195
// module chunks = 0